module.exports = __webpack_public_path__ + "img/boissons.bf62a1c0.svg";